<template>
  <div class="systemNews">
    <div class="systemNews-title">
      <span class="systemNews-head">系统消息</span>
    </div>
    <div v-if="noticeMsg.length > 0" class="systemNews-msgBox">
      <div v-for="(item,index) in noticeMsg" :key="index" class="systemNews-message" @click="go2Detail">
        <div v-if="item.type ==1">
          <span>{{item.subject}} 付款成功，收款金额  {{item.amount | fixed}}，点击查看详情</span>
          <span style="margin-left: 20px">{{item.createTime}}</span>
        </div>
        <div v-else-if="item.type ==2">
          <span>{{item.subject}} 提现成功，提现金额  {{item.amount | fixed}}，点击查看详情</span>
          <span style="margin-left: 20px">{{item.createTime}}</span>
        </div>
        <div v-else-if="item.type ==3">
          <span>驳回退款，退款金额{{item.amount | fixed}}元</span>
          <span style="margin-left: 20px">{{item.createTime}}</span>
        </div>
        <div v-else>

        </div>

      </div>
    </div>
    <div v-else class="systemNews-noMsgBox">
      暂无最新消息
    </div>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  import bus from '@/utils/BusEvent'

  export default {
    data () {
      return {}
    },
    computed: {
      ...mapGetters([
        'noticeMsg'
      ])
    },
    created () {
      // bus.$on('setData', () => {
      //   this.items = this.$store.getters.MSG
      //   this.showMsg = false
      //   if (this.items.length > 0) {
      //     this.showMsg = true
      //   }
      // })
    },
    methods: {
      go2Detail () {
        let data = {
          name: '交易管理',
          path: '/main/trademanage'
        }
        bus.$emit('addTab', data)
      }
    },
    watch: {},
    destroyed () {
      // this.disconnect();
    },
  }
</script>

<style lang="scss" scoped>
  @import '../style/mixin';
  @import '../style/_variables';

  .systemNews-title {
    @include flex-row;
    justify-content: space-between;
    // background-color: $head-bg;
    color: $color-52;
    font-size: $font-18;
    height: $head-height;
    padding: $head-padding;
    > .systemNews-head {
      border-left: $border-left-31;
      padding-left: 10px;
    }
  }

  .systemNews-msgBox {
    width: 96%;
    margin-left: 28px;
    border-bottom: 1px solid #eee;
    border-top: 1px solid #eee;
    margin-top: 12px;

  }

  .systemNews-message {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    width: 100%;
    padding: 5px 10px;
    // margin: 0 20px;
    background-color: #fff;
    font-size: $font-14;
    color: #7D8893;
    border-bottom: 1px solid #eee;
  }

  .systemNews {
    padding-bottom: 20px;
  }

  .systemNews-noMsgBox {
    width: 96%;
    margin-left: 28px;
    border-bottom: 1px solid #eee;
    border-top: 1px solid #eee;
    margin-top: 12px;
    padding: 60px 0;
    text-align: center;
  }
</style>



// WEBPACK FOOTER //
// src/components/SystemNews.vue